module.exports = __webpack_public_path__ + "static/img/fish.d99e4cc5.png";